import $ from 'jquery';
import { parseQuery, queryString } from '@/js/modules/query_params';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(function () {
    if (
      $('body').is('#library') ||
      $('body').is('#add-shoppables-to-billables-from-project') ||
      $('body').is('#add-shoppables-to-billables-from-library')
    ) {
      const checkboxSelector = '.checkbox--persist-on-page-reload';
      const toggleAllSelector = '.checkbox--toggle-all-items';

      /**
       * parse url and get ids
       * @return {Set<Integer>} - Set of integer ids
       */
      function getItemIds() {
        const params = queryString();
        let ids = (params['ids'] || '').split(',');
        if (ids[0] === '' && ids.length === 1) {
          ids = [];
        }
        return new Set(ids);
      }

      /**
       * sets given ids into url
       * @param {Set/Array<Integer>} ids - Set or arrays of ids(integer)
       */
      function setItemIds(ids) {
        const params = queryString();
        let url = null;
        params['ids'] = Array.from(ids).join(',');

        if (Object.keys(params).length > 0 && $.param(params).length > 0) {
          url = '?' + $.param(params);
        } else {
          url = window.location.pathname;
        }

        window.history.replaceState(null, '', url);
      }

      function updateHeaderControls(ids) {
        updateHeadCheckbox();
        updateGridButton(ids);
      }

      function updateActionDropdownItems({ enabled }) {
        const $actionItems = $('.dropdown-button--library-action .dropdown-button__item');
        $actionItems.attr('tabindex', enabled ? '0' : '-1');
        $actionItems.attr('aria-disabled', (!enabled).toString());

        if (!enabled) {
          $('.dropdown-button--library-action').removeClass('dropdown-button--active');
        }
      }

      function updateActionButton(ids) {
        const selectedItemsNum = (ids || getItemIds()).size;
        $('.dropdown-button--library-action .dropdown-button__counter').text('');
        $('.dropdown-button--library-action').addClass('dropdown-button--disabled');
        updateActionDropdownItems({ enabled: false });
        $('.p-button--billable-add-shoppables').prop('disabled', true);
        $('.billable-shoppable-selected-count').text('');
        $('.billable-shoppable-clear-selection').hide();
        if (selectedItemsNum > 0) {
          $('.dropdown-button--library-action .dropdown-button__counter').text(
            `(${selectedItemsNum})`
          );
          $('.dropdown-button--library-action').removeClass('dropdown-button--disabled');
          updateActionDropdownItems({ enabled: true });
          $('.p-button--billable-add-shoppables').prop('disabled', false);
          $('.billable-shoppable-selected-count').text(selectedItemsNum);
          $('.billable-shoppable-clear-selection').show();
        }
      }

      // Updates Grid button link according to the ids
      function updateGridButton() {
        const params = queryString();
        $('.library-view-mode__buttons a').each((index, link) => {
          const url = new URL(link.href);
          const localParams = parseQuery(url.search);
          params['library_view_mode'] = localParams['library_view_mode'];
          url.search = '?' + $.param(params);
          link.href = url.href;
        });
      }

      /**
       * Check if checkbox on the table head needs to be checked or not
       * if all the item in the table is selected, then also select
       * checkbox on the table head
       */
      function updateHeadCheckbox() {
        const isAllChecked = $(`${checkboxSelector}:not(:checked)`).length === 0;
        const isThereAnyCheckbox = $(checkboxSelector).length > 0;
        $(toggleAllSelector).prop('checked', isAllChecked && isThereAnyCheckbox);
      }

      /**
       * populate all checkboxes and delete button according to
       * search params in the URL
       */
      function populateItems() {
        const ids = getItemIds();

        $(checkboxSelector).prop('checked', false);
        ids.forEach(function (index, id) {
          $(`${checkboxSelector}[value=${id}]`).prop('checked', true);
        });

        updateHeaderControls(ids);
      }

      populateItems();
      updateActionButton();

      // On check box clicked
      $(document).on('change', checkboxSelector, function () {
        const ids = getItemIds();
        const id = $(this).val();
        if ($(this).is(':checked')) {
          ids.add(id);
        } else {
          ids.delete(id);
        }
        const newIds = Array.from(ids).join(',');

        if (ids.size > 0) {
          $('.pagination a').each(function (index, link) {
            const url = new URL(link.href);
            const params = parseQuery(url.search);
            params['ids'] = newIds;
            url.search = '?' + $.param(params);
            link.href = url.href;
          });
        }

        setItemIds(ids);
        updateHeaderControls(ids);
        updateActionButton(ids);
      });

      // On check box on table head clicked
      $(document).on('click', toggleAllSelector, function (e) {
        const checkState = $(this).is(':checked');
        $($(this).closest('table'))
          .find(checkboxSelector)
          .prop('checked', checkState)
          .trigger('change');
      });

      function clearSelections() {
        $(checkboxSelector).prop('checked', false).change();
        $('.pagination a').each(function (_, link) {
          const url = new URL(link.href);
          const params = parseQuery(url.search);
          params['ids'] = null;
          url.search = `?${$.param(params)}`;
          link.href = url.href;
        });
        setItemIds([]);
        updateActionButton([]);
      }

      $(document).on('click', '.dropdown-button__label--library-action', function () {
        const $currentDropdown = $(this).closest('.dropdown-button');
        const isDisabled = $currentDropdown.hasClass('dropdown-button--disabled');
        if (isDisabled) {
          $currentDropdown.removeClass('dropdown-button--active');
        }
      });
      // Archived cards have no checkbox, so archiving deselects the item
      $(document).on('ajax:success', '.dropdown-button__item--archive', (e, data) => {
        const $item = $(e.target).parents('.library-item');
        const ids = getItemIds();
        ids.delete(String($item.data('item-id')));
        $item.replaceWith(data);
        setItemIds(ids);
        populateItems();
        updateActionButton(ids);
      });

      $(document).on('turbo:custom:stream-render', populateItems);

      $('.dropdown-button__item--clear-selections').click(clearSelections);
      $('.billable-shoppable-clear-selection').click(clearSelections);
    }

    // always leave one checkbox checked in projects dropdown
    $(document).on('click', '.checkbox__label--projects-dropdown', (e) => {
      const checkedBoxes = $('.projects-dropdown__dropdown .checkbox:checked').length;
      if (checkedBoxes === 1 && $(e.currentTarget).prev('.checkbox').is(':checked')) {
        return false;
      }
    });
  });

  document.addEventListener('items--image-fields:primary-changed', ({ detail }) => {
    document
      .querySelectorAll(
        `.ui--thumbnail-card.library-item[data-item-id="${detail.itemId}"] .ui--thumbnail-card-media img`
      )
      .forEach((image) => {
        image.src = detail.primaryImageUrl;
      });
  });
});
